import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const PopupSuccess = ({ closePopupSuccess, copySuccess }) => {
  return (
    <Grid
      container
      style={{
        position: "fixed",
        bottom: "-13px",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        zIndex: 9999,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        borderRadius: "0px",
        padding: "10px 20px",
        minWidth: "250px",
        maxWidth: "400px",
      }}
    >
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Grid xs={1} item>
          <div className="icon-check-success" />
        </Grid>
        <Grid xs={10} item>
          <Typography
            className="color-blue-dark"
            style={{ marginLeft: "20px", marginTop: "2px" }}
          >
            {copySuccess}
          </Typography>
        </Grid>
        <Grid xs={1} item>
          <div
            className="icon-remove-file"
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={closePopupSuccess}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopupSuccess;
